import Table from 'react-table';
import styled, { css } from 'styled-components';

import './react-table.css';

const TableStyled = styled(Table)`
  & .rt-thead {
    background-color: ${(props) => props.theme.colors.primary};
  }
  & .rt-tr {
    ${({ alignItems }) =>
      alignItems &&
      css`
        align-items: ${alignItems};
      `};
  }
`;

export default TableStyled;
